import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_QUESTIONNAIRES_ROUTES } from "@/Generated/Routes/paths";

const questionnaires: RouteRecordRaw[] = [
  {
    ...APP_SETTINGS_QUESTIONNAIRES_ROUTES.root,
    meta: {
      i18nTitle: "questionnaires.questionnaires-title",
    },
    component: () => import("@/Views/settings/questionnaires/Questionnaires.vue"),
  },
];

export default questionnaires;
